import jsPDF from 'jspdf';
import 'jspdf-autotable';
import HTTPRequest from '../../../controllers/httpRequest.js';
import secureStorage from '../../../controllers/secureStorage.js';
import moment from 'moment';
import { mapState } from 'vuex';

var printOripox = {
    computed: {
        ...mapState(['profileId']),
    },
    methods: {
        async printORIPOX(isDefaultPrint, customFont) {
            this.spinning = true;

            let tabulatorInstance = this.$refs.tabulator.getInstance();
            let tableData = tabulatorInstance.getData();
            let documentDetails = this.documentDetails;

            const doc = new jsPDF('p', 'pt', 'a4');
            const pageWidth = doc.internal.pageSize.getWidth();
            const pageHeight = doc.internal.pageSize.getHeight();

            let xLeftKey = 35;
            let xRightKey = 560;
            let requestingSiteId = this.documentDetails.site_id.key;

            let siteData = await HTTPRequest.getRequest(`${this.endPoint}sites/${requestingSiteId}`, null, null);
            let companyData = await HTTPRequest.getRequest(`${this.endPoint}companies/${siteData.company_id }`, null, null);
            let supplierData = await HTTPRequest.getRequest(`${this.endPoint}suppliers/${this.supplier.key}`, null, null);
            var documentHistory = await HTTPRequest.getRequest(this.endPoint + "document_action_histories/"+documentDetails.id+"?field_name=document_id", null);
            var userName = secureStorage.getItem("userName");

            let isPrinted = false;

            let startY = 285
            let increaseBoxSize = 0

            // Check if any action in documentHistory is "Print Document"
            for (let i = 0; i < documentHistory.length; i++) {
                if (documentHistory[i].action === "Print Document") {
                    isPrinted = true;
                    break;
                }
            }
            
            function addHeader(doc, siteData, documentDetails, xLeftKey, xRightKey, pageWidth, pageNumber, pageCount) {
                doc.setFontSize(12);
                doc.setFontStyle("bold");
                doc.text(`${String(siteData.company_name).toUpperCase()}`, xLeftKey, 30);

                // left content
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                let companyAddress = doc.splitTextToSize(`${companyData.address ? `${String(companyData.address).toUpperCase()}` : ''}`, 260);
                doc.text(companyAddress, xLeftKey, 40);
                doc.text(`VAT REG TIN: ${companyData.tin || ''}`, xLeftKey, 60);
                doc.text(`TEL. NO.: ${companyData.telephone || ''} FAX No. ${companyData.fax || ''}` , xLeftKey, 70);

                // right Content
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text(`Page ${pageNumber}/${pageCount}`, xRightKey, 30, { align: 'right' });
                doc.setFontSize(10);
                doc.setFontStyle("bold");
                doc.text('PURCHASE ORDER', xRightKey, 45, { align: 'right' });
                doc.setFontSize(8.5);
                doc.text(`${handleNull(documentDetails.cas_no)}` || '', xRightKey, 60, { align: 'right' });
                doc.setFontSize(8);
                doc.setFontStyle("normal");              
                doc.text(`${isPrinted ? 'REPRINTED' : 'ORIGINAL'}  COPY`, xRightKey, 75, { align: 'right' });
            }
            function addSubHeader(doc, siteData,supplierData, documentDetails, xLeftKey, xRightKey, pageWidth, pageNumber, pageCount) {
            //for formatting length of text to avoid overlapping
            const splitTextToLines = (text, maxChars) => {
                const str = String(text);
                const lines = [];
                let currentLine = '';
            
                const words = str.split(/\s+/);
            
                for (const word of words) {
                    // If adding the word would exceed maxChars, push current line and start a new one
                    if ((currentLine + ' ' + word).trim().length > maxChars) {
                        if (currentLine) {
                            lines.push(currentLine.trim());
                        }
                        currentLine = word;
                    } else {
                        // Add word to current line (with a space if line is not empty)
                        currentLine += currentLine ? ' ' + word : word;
                    }
                }
            
                // Add the last line if not empty
                if (currentLine) {
                    lines.push(currentLine.trim());
                }
            
                return lines;
            };
            var supplier_address = [
                supplierData.billing_address && supplierData.billing_address.length > 0 ? supplierData.billing_address : '',
                supplierData.barangay_name && supplierData.barangay_name.length > 0 ? supplierData.barangay_name : '',
                supplierData.city_name && supplierData.city_name.length > 0 ? supplierData.city_name : '',
                supplierData.province_name && supplierData.province_name.length > 0 ? supplierData.province_name : '',
                supplierData.zip_code && supplierData.zip_code.length > 0 ? supplierData.zip_code : '',
                supplierData.country_name && supplierData.country_name.length > 0 ? supplierData.country_name : '',
            ].filter(address => address.length > 0).join(', ');
            let supplierAddressLength = String(supplier_address).length;
            let baseLength = 80;
            let lineHeight = 6; // line spacing unit
            let vendorInfoLineSpace = supplierAddressLength > baseLength 
                ? Math.ceil((supplierAddressLength - baseLength) / 20) * lineHeight 
                : 0;
                
            const increaseBoxSize = supplierAddressLength > 100 
            ? Math.ceil((supplierAddressLength - 100) / 10) * 8 
            : 0;

            doc.setLineWidth(1);
            doc.rect(xLeftKey, 90, pageWidth - 70, 185 + increaseBoxSize);
            doc.line(225, 90, 225, 275 + increaseBoxSize);
            doc.line(390, 90, 390, 275 + increaseBoxSize);
            startY = startY + increaseBoxSize
            var vendor_info = {
                name: splitTextToLines(supplierData.name, 28) || '',
                address:handleNull(splitTextToLines(String(supplier_address).substring(0,107), 28)) || '',
                contact_no: splitTextToLines(supplierData.telephone || '', 28),
                contact_info: splitTextToLines(supplierData.contact_person || '', 28)
            };
            var payment_info = {
                bill: splitTextToLines(supplierData.name, 28) || '',
                billing_address: handleNull(splitTextToLines(String(supplier_address).substring(0,107), 28)) || '',
                contact_no: handleNull(splitTextToLines(supplierData.telephone || '', 28)),
                contact_info: handleNull(splitTextToLines(supplierData.contact_person || '', 28)),
                terms: documentDetails.payment_term_id.label || ''
            };

            doc.setTextColor(0, 0, 255);
            doc.setFontStyle("bold");
            doc.text("VENDOR INFORMATION: ", xLeftKey + 5, 102);
            doc.setTextColor(0);
            doc.setFontSize(7)
            doc.text("Name", xLeftKey + 5, 112);
            doc.text("Address", xLeftKey + 5, 130)
            doc.text("Contact No.", xLeftKey + 5, 160 + vendorInfoLineSpace);
            doc.text("Contact Person", xLeftKey + 5, 170 + vendorInfoLineSpace);
            doc.setFontStyle("normal"); 
            doc.text(vendor_info.name, xLeftKey +65, 112);
            doc.text(vendor_info.address, xLeftKey +65, 130)
            //doc.text(vendor_info.address, xLeftKey +65, 135);
            doc.text(vendor_info.contact_no, xLeftKey +65, 160 + vendorInfoLineSpace);
            doc.text(vendor_info.contact_info, xLeftKey +65, 170 + vendorInfoLineSpace);

            doc.setTextColor(0, 0, 255);
            doc.setFontStyle("bold");
            doc.setFontSize(8);
            doc.text("PAYMENT INFORMATION: ", xLeftKey + 5, 185 + vendorInfoLineSpace);
            doc.setTextColor(0);
            doc.setFontSize(7);
            doc.text("Bill", xLeftKey + 5, 195 + vendorInfoLineSpace);
            doc.text("Billing Address", xLeftKey + 5, 212 + vendorInfoLineSpace);
            doc.text("Contact No.", xLeftKey + 5, 240 + (vendorInfoLineSpace * 2));
            doc.text("Contact Person", xLeftKey + 5, 250 + (vendorInfoLineSpace * 2));
            doc.text("Terms", xLeftKey + 5, 260 + (vendorInfoLineSpace * 2));
            doc.setFontStyle("normal");
            doc.text(payment_info.bill, xLeftKey +65, 195 + vendorInfoLineSpace);
            doc.text(payment_info.billing_address, xLeftKey +65, 212 + vendorInfoLineSpace);
            doc.text(payment_info.contact_no, xLeftKey +65, 240 + (vendorInfoLineSpace * 2));
            doc.text(payment_info.contact_info, xLeftKey +65, 250 + (vendorInfoLineSpace * 2));
            doc.text(payment_info.terms, xLeftKey +65, 260 + (vendorInfoLineSpace * 2));

            const formattedPoDate = documentDetails.document_date 
                ? moment(documentDetails.document_date).format('MM/DD/YYYY') 
                : '';
            const formattedEtd = documentDetails.target_date 
                ? moment(documentDetails.target_date).format('MM/DD/YYYY') 
                : '';
            var po_details = {
                po_no: documentDetails.cas_no || '',
                po_date: handleNull(formattedPoDate),
                etd: handleNull(formattedEtd),
                country_origin: documentDetails.country_id.label ? documentDetails.country_id.label : '',
                external_reference: splitTextToLines(documentDetails.oc_ref_no  || '', 20),
                remarks: documentDetails.remark || ''
            };

            let referenceLength = String(documentDetails.oc_ref_no).length;
            let remarkLength = String(documentDetails.oc_ref_no).length;

            let poDetailsLineSpace = referenceLength > 20 ? 8 : 0
            let orderSummaryLineSpace = remarkLength > 20 ? 8 : 0

            doc.setTextColor(0, 0, 255);
            doc.setFontStyle("bold");
            doc.setFontSize(8);
            doc.text("PO DETAILS:", 232, 102);
            doc.setTextColor(0);
            doc.setFontSize(7);
            doc.text("PO No.:", 232, 115);
            doc.text("PO Date", 232, 125);
            doc.text("ETD", 232, 135);
            doc.text("Country Origin", 232, 145);
            doc.text("External Reference", 232, 155);
            doc.text("Remarks", 232, 165 + poDetailsLineSpace);
            doc.setFontStyle("normal");
            doc.text(po_details.po_no, 300, 115);
            doc.text(po_details.po_date, 300, 125);
            doc.text(po_details.etd, 300, 135);
            doc.text(splitTextToLines(po_details.country_origin, 20), 300, 145);
            doc.text(po_details.external_reference, 300, 155);
            doc.text(splitTextToLines(po_details.remarks, 20), 300, 165 + poDetailsLineSpace);

            var order_summary = {
                brand: splitTextToLines(documentDetails.brand_names || '', 19),
                year_season:  documentDetails.year_season ||'',
                total_po_qty: documentDetails.total_quantity ||'',
                total_po_value: documentDetails.amount_net ||'',
                currency: documentDetails.currency_id.code ||''
            };
            var addLineSpace = String(documentDetails.brand_names).length > 19 ? 15 : String(documentDetails.brand_names).length > 38 ? 25 : 0
            doc.setTextColor(0, 0, 255);
            doc.setFontStyle("bold");
            doc.setFontSize(8  )
            doc.text("ORDER SUMMARY:", 232, 185 + orderSummaryLineSpace);
            doc.setTextColor(0);
            doc.setFontSize(7)
            doc.text("Brand", 232, 195 + orderSummaryLineSpace);
            doc.text("Year Season", 232, 205 + (orderSummaryLineSpace + addLineSpace));
            doc.text("Total PO Qty", 232, 215 + (orderSummaryLineSpace + addLineSpace));
            doc.text("Total PO Value", 232, 225 + (orderSummaryLineSpace + addLineSpace));
            doc.text("Currency", 232, 235 + (orderSummaryLineSpace + addLineSpace));
            doc.setFontStyle("normal");
            doc.text(order_summary.brand, 300, 195 + orderSummaryLineSpace);
            doc.text(order_summary.year_season, 300, 205 + (orderSummaryLineSpace + addLineSpace));
            doc.text(order_summary.total_po_qty, 300, 215 + (orderSummaryLineSpace + addLineSpace));
            doc.text(parseFloat(order_summary.total_po_value).toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2}), 300, 225 + (orderSummaryLineSpace + addLineSpace));
            doc.text(order_summary.currency, 300, 235 + (orderSummaryLineSpace + addLineSpace));
            var delivery_address = [
                companyData.address,
                documentDetails.boxme_location && documentDetails.boxme_location.length > 0 ? documentDetails.boxme_location[0]['province_name'] : '',
                documentDetails.boxme_location && documentDetails.boxme_location.length > 0 ? documentDetails.boxme_location[0]['district_name'] : '',
                documentDetails.boxme_location && documentDetails.boxme_location.documentDetailslength > 0 ? documentDetails.boxme_location[0]['subdistrict_name'] : ''
            ].filter(address => address.length > 0).join(', ');  
            var ship_to = {
                company_name: splitTextToLines(siteData.company_name, 20),
                delivery_address: handleNull(splitTextToLines(String(delivery_address).substring(0,107), 22)) || "",
                contact_no: splitTextToLines(siteData.landline_number || '', 23),
                contact_person: handleNull(splitTextToLines(siteData.regional_sales_head || '', 22))
            };
            let deliveryAddressLength = String(delivery_address).length;
            console.log(deliveryAddressLength)
            let shipToLineSpace = 
                deliveryAddressLength >= 125 ? 30 :
                deliveryAddressLength > 100 ? 25 :
                deliveryAddressLength > 75 ? 20 :
                deliveryAddressLength > 50 ? 10 : 0;
            doc.setTextColor(0, 0, 255);
            doc.setFontStyle("bold");
            doc.setFontSize( 8  )
            doc.text("SHIP TO:", 397, 102);
            doc.setTextColor(0);
            doc.setFontSize(7)
            doc.text("Company Name", 397, 115);
            doc.text("Delivery Address", 397, 140);
            doc.text("Contact No.", 397, 165 + shipToLineSpace);
            doc.text("Contact Person", 397, 180 + shipToLineSpace);
            doc.setFontStyle("normal");
            doc.text(handleNull(ship_to.company_name), 468, 115);
            // doc.text(handleNull(ship_to.delivery_address), 468, 140);
            doc.text(handleNull(splitTextToLines(String(documentDetails.address).substring(0,107), 30)), 468, 140);
            doc.text(handleNull(ship_to.contact_no), 468, 165 + shipToLineSpace);
            doc.text(handleNull(ship_to.contact_person), 468, 180 + shipToLineSpace);

            var special_instructions = { ship_via: documentDetails.shipping_method_id.label || '' };
            doc.setTextColor(0, 0, 255);
            doc.setFontStyle("bold");
            doc.setFontSize(8)
            doc.text("SPECIAL INSTRUCTIONS:", 397, 200 + shipToLineSpace);
            doc.setFontSize(7)
            doc.setTextColor(0);
            doc.text("Ship Via", 397, 230 + (deliveryAddressLength > 100 ? 10 : 0));
            doc.setFontStyle("normal");
            doc.text(special_instructions.ship_via, 468, 230 + (deliveryAddressLength > 100 ? 10 : 0));
            
            }
             // generate the first serial number from the prefix
            function generateFirstSerialNumber(casNo) {
                // split the cas_no to extract the prefix and current serial number
                const parts = casNo.split("-");
                const prefix = parts.slice(0, -1).join("-");
                const firstSerialNumber = `${prefix}-99999999`;
                return firstSerialNumber;
            }

            const currentSerialNumber = handleNull(documentDetails.cas_no);
            const firstSerialNumber = generateFirstSerialNumber(currentSerialNumber);

            function addFooter(doc, pageWidth, pageHeight,xLeftKey) {
                doc.setFontSize(7);
                doc.setFontStyle("bold");
                doc.text("Prepared by: " + documentDetails.created_by, (pageWidth * 0.15), pageHeight - 105)
                doc.text("Noted by:", (pageWidth * 0.4), pageHeight - 105)
                doc.text("Approved by:", (pageWidth * 0.65), pageHeight - 105)
                doc.setLineHeightFactor(1.5);
                doc.text('NOTE: THIS COPY SHOULD BE ATTACHED TO THE BILL OF CREDITOR WHEN COLLECTION IS DEMANDED. NO PURCHASES WILL BE HONORED \nWITHOUT THIS ACCOMPANYING PURCHASE ORDER', (pageWidth/2), pageHeight - 83 , {align: 'center' });
                doc.setFontStyle("bolditalic");
                doc.text('"THIS DOCUMENT IS NOT VALID FOR CLAIM OF INPUT TAX"',(pageWidth/2), pageHeight - 63 , {align: 'center' });
                doc.rect(xLeftKey, pageHeight - 92, pageWidth - 70, 22);
                const currentDate = moment().format('MM/DD/YYYY');
                const currentTime = moment().format('HH:mm');
                
                doc.setFontSize(8);
                doc.setFontStyle("normal");
                doc.text('Acknowledgement Certificate: ' + handleNull(companyData.cas_permit_number), 40, pageHeight - 48);
                doc.text(`Date Issued: ${moment(companyData.acknowledgement_receipt_date_issue).format("MMMM D, YYYY")}`, 40, pageHeight - 35);
                //doc.text(`Serial Number Range: ${currentSerialNumber + ' - ' + firstSerialNumber || ''}`, 40, pageHeight - 20);
                doc.text(`Serial Number Range: ${'PO' + '-TR ' + documentDetails.company_code + '-' +  companyData.series_number_range.split('-')[0] + ' - ' + 'PO' + '-TR ' + documentDetails.company_code + '-' +  companyData.series_number_range.split('-')[1]}`, 40, pageHeight - 20);
                doc.text(`${documentDetails.status}`, pageWidth - 40, pageHeight - 50, { align: 'right' });
                doc.text(`${userName}`, pageWidth - 40, pageHeight - 35, { align: 'right' });
                doc.text(`${currentDate} ${currentTime}`, pageWidth - 40, pageHeight - 20, { align: 'right' });
            }

            function handleNull(value) {
                return value == null ? '' : value;
            }

            addHeader(doc, siteData, documentDetails, xLeftKey, xRightKey, pageWidth, 1, 1);
            addSubHeader(doc, siteData, supplierData, documentDetails, xLeftKey, xRightKey, pageWidth, 1, 1);

            const tableColumn = [
                { header: 'Vendor Item No.', dataKey: 'vendor_item_no' },
                { header: 'Item Description', dataKey: 'product_name' },
                { header: 'No.', dataKey: 'barcode' },
                { header: 'Total Qty', dataKey: 'quantity' },
                { header: 'Per Unit FOB Price', dataKey: 'price' },
                { header: 'Line Discount', dataKey: 'discount' },
                { header: 'Total Amount', dataKey: 'subtotal' },
            ];

            function extractValues(data, keys) {
                return data.map(row => {
                    const newRow = {};
                    keys.forEach(column => {
                        if (row.hasOwnProperty(column.dataKey)) {
                            if (column.dataKey === 'price' || column.dataKey === 'subtotal' || column.dataKey === 'discount') {
                                // format amount of money w/ commas and w/ 2 decimal places
                                newRow[column.dataKey] = parseFloat(row[column.dataKey]).toLocaleString(undefined, {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                });
                            } else if (column.dataKey === 'quantity') {
                                // format quantity as a whole number and 0 if null or undifined
                                const value = parseFloat(row[column.dataKey]);
                                newRow[column.dataKey] = value != null && !isNaN(value)
                                ? Math.round(value).toLocaleString()
                                : '0';
                            } else {
                                newRow[column.dataKey] = row[column.dataKey];
                            }
                        }
                    });
                    return newRow;
                });
            }

            const totalQuantity = tableData.reduce((sum, row) => sum + (parseFloat(row.quantity) || 0), 0);
            const totalAmount = tableData.reduce((sum, row) => sum + (parseFloat(row.subtotal) || 0), 0);
            //const totalDiscount = tableData.reduce((sum, row) => sum + (parseFloat(row.discount) || 0), 0);
            const totalDiscount = documentDetails.amount_header_discount;
            const totalAmountWithDiscount = totalAmount - totalDiscount;
                const formattedTotalAmount =  Number(totalAmount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').toString();
            // format money-related values with commas and two decimal places
            
            const formattedTotalDiscount =  Number(totalDiscount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').toString();
            const formattedTotalAmountWithDiscount =  Number(totalAmountWithDiscount).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').toString();

            const extractedData = extractValues(tableData, tableColumn);
            
            extractedData.push(
                { column1: '', column2: '', column3: '', column4: '', column5: '', column6: '', column7: '' },
                {
                    column1: '',
                    column2: '',
                    column3: '',
                    column4: totalQuantity.toLocaleString(),
                    column5: '',
                    column6: '',
                    column7: formattedTotalAmount,
                },
                {
                    column1: '',
                    column2: '',
                    column3: '',
                    column4: '',
                    column5: 'Less: Invoice Discount Amount',
                    column6: '',
                    column7: formattedTotalDiscount,
                },
                {
                    column1: '',
                    column2: '',
                    column3: '',
                    column4: '',
                    column5: { content: 'Total Purchases', styles: { fontStyle: 'bold' } },
                    column6: '',
                    column7: { content: formattedTotalAmountWithDiscount, styles: { fontStyle: 'bold' } },
                }
            );

            const cellsToUnderline = [
                { row: extractedData.length - 3, column: 3, type: 'double' },  // Total Quantity
                { row: extractedData.length - 3, column: 6, type: 'single' },  // Total Amount
                { row: extractedData.length - 2, column: 6, type: 'single' },   // Total discount
                { row: extractedData.length - 1, column: 6, type: 'double' }   // Total Purchases
            ];      

            while (extractedData.length < 18) {
                extractedData.push({ column1: '', column2: '', column3: '', column4: '', column5: '', column6: '', column7: '' });
            }
            doc.autoTable({
                theme: 'plain',
                head: [tableColumn.map(col => col.header)],
                body: extractedData.map(row => Object.values(row)),
                startY: startY,
                styles: { fontSize: 8 },
                margin: { left: 35, right: 35, top: 100, bottom: 100 },
                headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], halign: 'center' },
                bodyStyles: { halign: 'center' },
                columnStyles: {
                    1: { halign: 'left' }, 
                    2: { halign: 'left' },
                    3: { halign: 'right' },
                    4: { halign: 'right' },
                    5: { halign: 'right' },
                    6: { halign: 'right' }, 
                    7: { halign: 'right' }, 
                },
                tableLineColor: [0, 0, 0],
                tableLineWidth: 0.5,
                pageBreak: 'auto',

                didParseCell: function(data) {
                    const { row, column } = data;
                    // Adjust the row index calculation
                    const actualRowIndex = row.index; // This will reference the actual row index in extractedData
                    
                    const cellToUnderline = cellsToUnderline.find(
                        cell => cell.row === actualRowIndex && cell.column === column.index
                    );
                    
                    if (cellToUnderline) {
                        data.cell.styles.underline = cellToUnderline.type;
                    }
                },
                
                didDrawCell: function(data) {
                    if (data.cell.styles.underline) {
                        const {x, y, width, height} = data.cell;
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.5);

                        if (data.cell.styles.underline === 'single') {
                            doc.line(x, y + height - 4, x + width, y + height - 4);
                        } else if (data.cell.styles.underline === 'double') {
                            doc.line(x, y + height - 4, x + width, y + height - 4);
                            doc.line(x, y + height - 2, x + width, y + height - 2);
                        }
                        if (data.cell.raw == formattedTotalAmount){
                            doc.line(xLeftKey, y + height + 2, pageWidth - 35, y + height + 3);
                        }
                    }
                },
                didDrawPage: function (data) {
                    if (data.pageNumber > 1) {
                        addHeader(doc, siteData, documentDetails, xLeftKey, xRightKey, pageWidth, data.pageNumber, data.pageCount);
                    }
                },
            });

            // let finalY = doc.lastAutoTable.finalY + 30;
            
            addFooter(doc, pageWidth, pageHeight, xLeftKey);
            
            this.spinning = false;
            let pdfWindow = window.open(doc.output('bloburl'), '_blank');
            // Add manual print trigger button
            const detectBrowser = () => {
                const agent = window.navigator.userAgent.toLowerCase();
                if (agent.indexOf('edg') > -1) return 'Microsoft Edge';
                if (agent.indexOf('chrome') > -1) return 'Google Chrome';
                if (agent.indexOf('safari') > -1) return 'Safari';
                return 'Not Supported Browser';
            };
        
            const detectColorScheme = () => {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    return 'dark';
                }
                return 'light';
            };
        
            const browserName = detectBrowser();
            const colorScheme = detectColorScheme();
            const browserColors = {
                'Google Chrome': {
                    dark: 'rgb(51, 54, 57)',
                    light: 'white'
                },
                'Microsoft Edge': {
                    dark: 'rgb(59, 59, 59)',
                    light: 'rgb(247, 247, 247)'
                },
                'Safari': {
                    dark: 'rgb(44, 44, 44)',
                    light: 'white'
                },
                'default': {
                    dark: 'rgb(30, 33, 36)',
                    light: 'white'
                }
            };
            const getBackgroundColor = () => {
                const browserColorConfig = browserColors[browserName] || browserColors['default'];
                return browserColorConfig[colorScheme];
            };
            
            if (!isPrinted){
                pdfWindow.addEventListener('load', () => {
                    const printButton = pdfWindow.document.createElement('button');
                    printButton.style.position = 'fixed';
                    printButton.style.top = browserName == 'Microsoft Edge' ? '2px' : '10px';
                    printButton.style.right = '10px';
                    printButton.style.zIndex = '9999';
                    printButton.style.marginRight = '44px';
                    printButton.style.backgroundColor = getBackgroundColor();
                    printButton.style.border = 'none'; 
                    printButton.style.padding = browserName == 'Microsoft Edge' ? '10px 40px': '10px 20px'; 
                    printButton.style.cursor = 'pointer';
                    printButton.style.color = colorScheme == 'dark'? 'white' : 'black'
                    printButton.style.fontSize = '15px'
    
                    const fontAwesomeLink = pdfWindow.document.createElement('link');
                    fontAwesomeLink.rel = 'stylesheet';
                    fontAwesomeLink.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
                    pdfWindow.document.head.appendChild(fontAwesomeLink);
                
                    printButton.innerHTML = '<i class="fas fa-print"></i> Print';
                    
                    printButton.addEventListener('click', () => {
                        pdfWindow.print()
                        this.create_action_history('Print Document', documentDetails.id)
                    });
                    pdfWindow.document.body.appendChild(printButton);
                });
            }
        },
        async create_action_history(action,doc_no) {
            var actionHistoryPayload = {
                action: action,
                action_at: moment(new Date()),
                action_by: secureStorage.getItem("userName"),
                document_id: doc_no,
                status: "A"
            }
            await HTTPRequest.postRequest(this.endPoint + 'document_action_histories/', null, actionHistoryPayload)
        },
    }
}

export default printOripox;